<template>
  <div class="puzzle-box">
    <!-- <div id="sc"></div> -->
    <div id="captcha" />
  </div>
</template>

<script>
export default {
  name: 'Puzzle',
  props: {
    isReset: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {}
  },
  watch: {
    isReset() {
      this.resetPuzzle()
    }
  },
  mounted() {
    const _this = this
    // document.getElementById('getCode').onclick = function() {
    //   _this.doit()
    // }
  },
  methods: {
    doit() {
      const _this = this

      window.NVC_Opt.nvcCallback = function() {
        // 设置滑动成功回调
        _this.$emit('adopt')
      }
      const params = window.getNVCVal()
      _this.axios
        .post('/api-auth/thirdPartLogin/public/getAliyunAcs', {
          nvcdata: params
        },{noToken: true})
        .then(res => {
          if (res.datas == '400' || res.datas == '800' || res.datas == '900') {
            //唤醒滑动验证
            _this.$message.error('请进行智能验证')
            getNC().then(function() {
              _nvc_nc.upLang('cn', {
                _startTEXT: '请按住滑块，拖动到最右边',
                _yesTEXT: '验证通过',
                _error300:
                  '哎呀，出错了，点击<a href="javascript:location.reload()">刷新页面</a>',
                _errorNetwork:
                  '网络不给力，请< a href="javascript:location.reload()">刷新页面</ a>'
              })
              _nvc_nc.reset()
            })
          } else if (res.datas == '600') {
            //唤醒刮刮卡
            getSC().then(function() {})
          } else if (res.datas == '100' || res.datas == '200') {
            //注册成功
            // alert("register success!")
            // console.log('验证通过')
            _this.isSuccess = true
            _this.$emit('adopt')
          }
        })
    },
    resetPuzzle() {
      getNC().then(function() {
        _nvc_nc.reset()
      })
    }
  }
}
</script>

<style lang="scss" scope>
.puzzle-box {
  margin: 20px 0;
}
#sc {
  margin: 0;
  width: 320px;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
#SM_BTN_1 {
  width: 320px !important;
}
#SM_POP_1 {
  margin-left: 10px;
}
#rectMask {
  width: 322px !important;
}
#rectTop {
  width: 322px !important;
}
.nc_scale {
  background: #e8e8e8 !important;
}

.nc_scale div.nc_bg {
  background: #7ac23c !important;
}

.nc_scale .scale_text2 {
  color: #fff !important;
}

.nc_scale span {
  border: 1px solid #ccc !important;
}

.errloading {
  border: #faf1d5 1px solid !important;
  color: #ef9f06 !important;
  width: 320px !important;
}

.nc-container .nc_wrapper {
  width: 320px !important;
}
</style>
